<template>
    <div class="budgetary-legitimation-document">

        <numeric-question v-if="! singleSignature" v-model="numberOfSignatures" :min="1">
            ¿Cuántas personas firman el documento?

            <div slot="single">
                <international-document ref="international" @updated="update"
                                        :has-international-document.sync="hasInternationalDoc"></international-document>
            </div>

            <assertive-question slot="multiple" v-model="allSignaturesLegitimated">
                ¿Se legitiman las firmas de las {{ numberOfSignatures }} personas?

                <international-document slot="afirmative" ref="international" @updated="update"
                                        :has-international-document.sync="hasInternationalDoc"></international-document>

                <numeric-question slot="negative" v-model="numberOfLegitimatedSignatures" :min="1" :max="numberOfSignatures - 1">
                    Indica entonces el nº de firmas a legitimar:

                    <international-document slot="answered" ref="international" @updated="update"
                                            :has-international-document.sync="hasInternationalDoc"></international-document>
                </numeric-question>
            </assertive-question>
        </numeric-question>

        <international-document v-else ref="international" @updated="update"
                                :has-international-document.sync="hasInternationalDoc"></international-document>

    </div>
</template>

<script>
    export default {
        props: {
            singleSignature: Boolean,
            hasInternationalDocument: Boolean
        },

        data: function () {
            return {
                cost: 0,
                untaxedCosts: 0,
                completed: false,
                requiresAct: false,
                foliosNumber: 0,

                COST_PER_LEGITIMATION: 500 / 166.386, //3.005061

                numberOfSignatures: null,
                allSignaturesLegitimated: null,
                numberOfLegitimatedSignatures: null,
            }
        },

        computed: {
            costs: function () {
                return { cost: this.cost, untaxedCosts: this.untaxedCosts };
            },
            hasInternationalDoc: {
              set (value) {
                this.$emit('update:hasInternationalDocument', value)
              },
              get () {
                return this.hasInternationalDocument
              }
          }
        },

        mounted: function () {
            this.updateProgress();
        },

        methods: {
            update: function ( completed ) {
                this.completed = completed;
                this.updateProgress();
                this.calculate();
                this.requiresAct = this.completed ? this.$refs.international.isInternational : false;
                this.foliosNumber = this.$refs.international.foliosNumber;
                this.$emit( 'updated', this.completed );
            },
            calculate: function () {
                this.cost = this.untaxedCosts = 0;

                if ( this.numberOfSignatures === 1 || this.singleSignature ) this.cost = this.COST_PER_LEGITIMATION * 2;

                if ( this.numberOfSignatures > 1 ) {

                    if ( this.allSignaturesLegitimated == null ) return this.costs;

                    if ( this.allSignaturesLegitimated )
                    {
                        if ( this.numberOfSignatures == null ) return this.costs;
                        this.cost = this.numberOfSignatures * this.COST_PER_LEGITIMATION + this.COST_PER_LEGITIMATION;

                    } else {

                        if ( this.numberOfLegitimatedSignatures == null ) return this.costs;
                        this.cost = this.numberOfLegitimatedSignatures * this.COST_PER_LEGITIMATION + this.COST_PER_LEGITIMATION;
                    }
                }

                if ( this.$refs.international == null ) return this.costs;

                this.cost += this.$refs.international.cost;
                this.untaxedCosts += this.$refs.international.untaxedCosts;

                return this.costs;
            },
            updateProgress: function () {
                if ( this.$parent.$options.name == 'accordion' ) {
                    this.$parent.$slots.title[1].elm.innerHTML = this.completed ? 'COMPLETADO' : 'FALTA COMPLETAR';
                    this.$parent.$slots.title[1].elm.className = this.completed ? 'text-success' : 'text-warning';
                }
            },
            getJSON: function () {

                if ( this.singleSignature ) return this.$refs.international.getJSON();
                
                let json = [];

                json.push( { 
                    "name": "¿Cuántas personas firman el documento?", 
                    "value": this.numberOfSignatures 
                } );
                json.push( { 
                    "name": "¿Se legitiman las firmas de las "+this.numberOfSignatures+" personas?", 
                    "value": this.allSignaturesLegitimated 
                } );
                json.push( { 
                    "name": "Indica entonces el nº de firmas a legitimar:",
                    "value": this.numberOfLegitimatedSignatures 
                } );

                return json.concat( this.$refs.international.getJSON() );
            }
        },

        components: {
            'international-document': require('./InternationalDocument.vue')
        }
    }
</script>

<style lang="scss">
    @import "../../../../sass/variables";

    .budgetary-numeric-question {
        //
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/budgetary/legitimations/LegitimationDocument.vue